<template>
  <div>
    <div class="app-top">
      <!-- 轮播大图 -->
      <swiper-list :dataList="softPrice.intros" :height="500" :interval="20000"></swiper-list>
    </div>
    <!-- 图文详情 -->
    <intro-list :dataList="softPrice.intros"></intro-list>
    <div
      class="my-text-center my-p-10 my-m-t-10"
      style="background-color: #f8f8f8;"
      data-aos="fade-up"
      data-aos-offset="0"
      data-aos-delay="50"
      data-aos-duration="800"
    >
      <h2>我们的优势</h2>
      <!-- 优势特点 -->
      <feature-list :dataList="softPrice.intros" class="my-p-t-20" />
    </div>
    <div class="wrap-appointment" data-aos="fade-up" data-aos-offset="0" data-aos-delay="50" data-aos-duration="800">
      <h2>免费试用，专属客服耐心讲解</h2>
      <appointment />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import swiperList from '@/_myComponents/swiperList'
import introList from '@/_myComponents/introList'
import featureList from '@/_myComponents/featureList'
import Appointment from '@/_myComponents/Appointment'
// import { getToken } from '@/utils/auth'

export default {
  name: 'homeIndex',
  components: {
    swiperList,
    introList,
    featureList,
    Appointment
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  mounted() {},
  created() {
    //保存邀请码
    this.onloadArgs.saveInvite(this.$route.query)

    localStorage.setItem('test_key', 'a' + new Date())

    // let val = localStorage.getItem('test_key')
    // console.log('test_key', val)
    // console.log('getToken', getToken())

    //提前加载数据
    this.utils.refreshSoftPrice(this.onloadArgs.getInvite())
    this.utils.refreshVideoList()
    this.utils.refreshHelpList()
    this.utils.refreshHelpCates()
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
/* 手机版 */
@media screen and (max-width: 576px) {
  h2 {
    font-size: 28px !important;
  }

  p {
    font-size: 22px !important;
  }

  .wrap-appointment {
    padding-bottom: 40px 5px !important;

    h2 {
      font-size: 22px !important;
      font-weight: 500 !important;
    }
  }
}

/* 电脑版 */
.app-top {
  margin-top: 58px;
}

h2 {
  font-weight: bold;
  line-height: 180%;
  margin-top: 20px;
}

p {
  line-height: 140%;
}

.wrap-appointment {
  background-image: url('../../assets/images/appointment-bg.png');
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
}
</style>